import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/toPromise';
import { ApiUrlConstants } from '../../common/constants/api.constants';
import { CacheService } from './cache.service';
import { CacheKey } from '../constants/cachekey.constants';
import { AppCountryConfig } from '../../app-country-config.interface';
import { AppConfigService } from '../../app-config.service';
import { catchError } from 'rxjs/internal/operators';
import { MemberOrderRestrictionResponse } from '../interfaces/member-order-restriction.response';
import { MemberType } from '../enums/member-type.enum';
import { Member } from '../interfaces/member.interface';
import { MemberLevel } from '../enums/member-level.enum';
import { MemberOrderType } from '../enums/member-order-type.enum';
import { HttpClient } from '@angular/common/http';
import { MemberOrderRestrictionInfo } from '../interfaces/member-order-restriction-info.interface';
import * as moment from 'moment';
import { ReportOnlyCountryService } from './report-only-country.service';

@Injectable()
export class MemberOrderRestrictionService {
    private memberOrderRestrctionInfo: MemberOrderRestrictionResponse;
    appCountryConfig: AppCountryConfig;
    isoCountryCode: string;


    constructor(private _http: HttpClient,
        private _cacheService: CacheService,
        private _reportOnlyCountryService: ReportOnlyCountryService,
        private _appConfigService: AppConfigService) {
        this.isoCountryCode = this._cacheService.getCookieValue(CacheKey.countryCode);
        this.appCountryConfig = this._appConfigService.getSettings(this.isoCountryCode);
    }

    setMemberOrderRestrictionInfo(response: MemberOrderRestrictionResponse): void {
        this.memberOrderRestrctionInfo = response;
    }

    /**
   * @description getMemberOrderRestrictionsInfo
   * @date 2020-02-05
   * @returns {Observable<MemberOrderRestrictionResponse>}
   * @memberof
   */
    getOrderRestrictionsInfo(): MemberOrderRestrictionResponse {
        if (this.memberOrderRestrctionInfo) {
            return this.memberOrderRestrctionInfo;
        }
    }

    /**
   * @description validateUserByRestrictOrderRule
   * @date 2020-02-05
   * @memberof
   */
    validateUserByRestrictOrderRule(): MemberOrderRestrictionInfo {
        let displayRestrictOrderNotification = false;
        const userInfo: Member = this._cacheService.get(CacheKey.UserInfo);
        if (!this.memberOrderRestrctionInfo && this._cacheService.get(CacheKey.MemberOrderRestrictionInfo)) {
            this.memberOrderRestrctionInfo = this._cacheService.get(CacheKey.MemberOrderRestrictionInfo);
        }
        if (this.appCountryConfig.restrictOrder && userInfo && userInfo.memberTypeId === MemberType.DISTRIBUTOR
            && this.memberOrderRestrctionInfo && !this.memberOrderRestrctionInfo.nextOrderEligible) {
            const restrictedDays = this.memberOrderRestrctionInfo.restrictedDays;
            const dateParts = userInfo.enrollmentDate.split('-');
            const enrollmentDate = new Date(+dateParts[0], +dateParts[1] - 1, +dateParts[2]);
            if (enrollmentDate && restrictedDays) {
                enrollmentDate.setHours(0, 0, 0, 0);
                enrollmentDate.setDate(enrollmentDate.getDate() + restrictedDays);
                const currentDate = new Date();
                currentDate.setHours(0, 0, 0, 0);
                if (enrollmentDate.getTime() > currentDate.getTime()) {
                    displayRestrictOrderNotification = true;
                }
            }
            const memberOrderRestrictionInfo: MemberOrderRestrictionInfo = {
                memberOrderRestricted: displayRestrictOrderNotification,
                nextOrderEligibleDate: moment(enrollmentDate).format('DD-MMM-YYYY')
            };
            return memberOrderRestrictionInfo;
        }
    }


    /**
     * @description getMemberOrderRestrictionsInfo
     * @date 2020-02-05
     * @returns {Observable<MemberOrderRestrictionResponse>}
     * @memberof
     */
    getMemberOrderRestrictionsInfo(countryCode: string): Observable<MemberOrderRestrictionResponse> {
        if (this._reportOnlyCountryService.reportOnlyCountry(this.isoCountryCode)) {
            return Observable.of({} as MemberOrderRestrictionResponse);
        }
        const userInfo: Member = this._cacheService.get(CacheKey.UserInfo);
        if (userInfo && userInfo.memberTypeId === MemberType.PREFERREDCUSTOMER) {
            userInfo.memberTitleId = MemberLevel.PREFERREDCUSTOMER;
        }
        const orderType = userInfo && userInfo.memberTitleId !== MemberLevel.RETAIL ? MemberOrderType.Wholesale
            : MemberOrderType.Retail;
        const memberTitleId = userInfo ? userInfo.memberTitleId : MemberLevel.RETAIL;
        const getURL = ApiUrlConstants.orderApiUrl + '/V1/member-order-restrictions?memberTitleId='
            + memberTitleId + '&countryCode=' + countryCode + '&orderType=' + orderType;
        return this._http
            .get<MemberOrderRestrictionResponse>(getURL)
            .pipe(catchError(this.handleErrorObservable));
    }

    /**
     * To handle the obervable error response
     * @param  {Response|any} error
     */
    private handleErrorObservable(error: Response | any) {
        return Observable.throw(error);
    }

}
